import React from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  HStack,
  Icon,
  GridItem,
  Circle,
  Image,
} from "@chakra-ui/react";

const ServiceCard = ({ service }) => (
  <GridItem key={service.id}>
    <Box
      bg="white"
      borderRadius="xl"
      p={4}
      border="1px"
      borderColor="gray.200"
      shadow="sm"
      h="full"
      position="relative"
      transition="all 0.3s ease"
      _hover={{
        shadow: "md",
        transform: "translateY(-2px)",
      }}
    >
      <HStack align="center" spacing={2} h="full">
        <Circle
          size="50px"
          // bg={service.bgColor}
          color={service.iconColor}
          flexShrink={0}
        >
          {typeof service.icon === 'string' && service.icon.includes('.svg') ? (
            <Image
              src={service.icon}
              alt={service.title}
              boxSize={12}
              filter={service.iconColor === 'white' ? 'none' : 'none'}
            />
          ) : (
            <Icon as={service.icon} boxSize={12} />
          )}
        </Circle>
        <VStack align="start" spacing={1} flex={1} justify="center">
          <Heading size="sm" color="#000B8C" fontWeight="normal">
            {service.title}
          </Heading>
          <Text color="gray.600" fontSize="sm" lineHeight="1.6">
            {service.description}
          </Text>
        </VStack>
      </HStack>
    </Box>
  </GridItem>
);

export default ServiceCard;